export function toggleNavDropdown(toggle) {
  const subMenuContainerId = toggle.getAttribute("aria-controls");

  if (!subMenuContainerId) {
    return;
  }

  const subMenuContainer = document.getElementById(subMenuContainerId);
  const subnavContainer = document.querySelector(".js-subnav-container");
  const menuExpanded = toggle.getAttribute("aria-expanded");
  const menuItem = subMenuContainer.closest("li");
  const icon = toggle.querySelector("i");

  if ("false" === menuExpanded) {
    // We need to expand this dropdown. Since only one dropdown is allowed to be open at a time check for others and close if any are found.
    const openItems = document.querySelectorAll(".js-nav-item-has-children.show");

    if (openItems) {
      [].slice.call(openItems).forEach(item => {
        const toggle = item.querySelector(".js-dropdown-toggle");
        toggle && toggleNavDropdown(toggle);
      });
    }

    toggle.setAttribute("aria-expanded", "true");
    menuItem.classList.add("show", "toggled");
    subMenuContainer.classList.add("show");
    subnavContainer.classList.add("show");
    subnavContainer.style.height = `${subMenuContainer.offsetHeight + 1}px`; // Account for border positioning
    icon.classList.remove("fa-angle-down");
    icon.classList.add("fa-angle-up");
  } else {
    toggle.setAttribute("aria-expanded", false);
    menuItem.classList.remove("show", "toggled");
    subMenuContainer.classList.remove("show");
    subnavContainer.classList.remove("show");
    subnavContainer.style.height = null;
    icon.classList.remove("fa-angle-up");
    icon.classList.add("fa-angle-down");
  }
}

export function openHoverDropdown(toggle) {
  const subMenuContainerId = toggle.getAttribute("aria-controls");

  if (!subMenuContainerId) {
    return;
  }

  const subMenuContainer = document.getElementById(subMenuContainerId);
  const subnavContainer = document.querySelector(".js-subnav-container");
  const menuItem = subMenuContainer.closest("li");
  const icon = toggle.querySelector("i");

  // Nothing to do if the item is already open
  // mouseenter can fire for already open items again
  if (menuItem.classList.contains("show")) {
    return;
  }

  // We need to expand this dropdown. Since only one dropdown is allowed to be open at a time check for others and close if any are found.
  const openItems = document.querySelectorAll(".js-nav-item-has-children.show");

  if (openItems) {
    [].slice.call(openItems).forEach(item => {
      const toggle = item.querySelector(".js-dropdown-toggle");
      toggle && toggleNavDropdown(toggle);
    });
  }

  toggle.setAttribute("aria-expanded", "true");
  menuItem.classList.add("show");
  subMenuContainer.classList.add("show");
  subnavContainer.classList.add("show");
  subnavContainer.style.height = `${subMenuContainer.offsetHeight + 1}px`; // Account for border positioning
  icon.classList.remove("fa-angle-down");
  icon.classList.add("fa-angle-up");
}

export function closeHoverDropdown(toggle) {
  const subMenuContainerId = toggle.getAttribute("aria-controls");

  if (!subMenuContainerId) {
    return;
  }

  const subMenuContainer = document.getElementById(subMenuContainerId);
  const menuItem = subMenuContainer.closest("li");
  const icon = toggle.querySelector("i");
  const subnavContainer = document.querySelector(".js-subnav-container");

  if (menuItem.classList.contains("toggled")) {
    // Do not close the dropdown if it was toggled by button click
    return;
  }

  toggle.setAttribute("aria-expanded", false);
  menuItem.classList.remove("show");
  subMenuContainer.classList.remove("show");
  subnavContainer.classList.remove("show");
  subnavContainer.style.height = null;
  icon.classList.remove("fa-angle-up");
  icon.classList.add("fa-angle-down");
}
